import { Component, Input, OnInit, AfterViewInit, OnChanges, SimpleChanges, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { EstacaoService } from 'src/services/estacao.service';
import { VariavelService } from 'src/services/variavel.service';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';
import { SortEvent } from 'primeng/api';

@Component({
    selector: 'app-variavel',
    templateUrl: './variavel.component.html',
    styleUrls: ['./variavel.component.scss'],
    standalone: false
})
export class VariavelComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  rangeDate: any[] = [];
  // value: any[] = [];
  // columns: any[] = [];
  tipos_variaves: any[] = [];
  dropDownTipoVariavel: any[] = [];
  dropDownEstacao: any[] = [];
  tipo_variavel: any[] = []
  estacao_id: any
  // descricao_estacao: any
  @Input() value;
  @Input() descricao_estacao;
  @Input() columns;
  @Input() estacaoColetas: any[] = [];
  @Input() exibirMarcacoesEvento = false;
  @Input() exibirCabecalhoExportacao = true;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '400px';
  private resizeObserver: ResizeObserver | null = null;
  private ordenacaoAtual: { field: string; order: 1 | -1 } | null = null;
  cols: any[] = [
    { field: 'estacao', header: 'Estação' },
    { field: 'tipo_variavel', header: 'Tipo Variavel' },
    { field: 'valor', header: 'Valor' },
    { field: 'data_hora_dado', header: 'Data' },
  ];

  constructor(
    protected _variavelService: VariavelService,
    protected _estacaoService: EstacaoService,

  ) { }

  /**
   * Formata um valor numérico baseado no número de casas decimais configurado para a variável
   * @param value Valor numérico a ser formatado
   * @param tipoVariavelNome Nome do tipo de variável (ex: 'NIVEL', 'BATERIA')
   * @returns Valor formatado como string
   */
  getMarcacoesColuna(row: any, coluna: string): any[] {
    return row?.marcacoesPorColuna?.[coluna] || [];
  }

  temMarcacoesNaColuna(row: any, coluna: string): boolean {
    return this.getMarcacoesColuna(row, coluna).length > 0;
  }

  formatarValor(value: number | string, tipoVariavelNome: string): string {
    const numValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
    if (isNaN(numValue)) return value.toString();

    // Busca o tipo de variável pelo nome para encontrar o ID
    const tipoVariavel = this.dropDownTipoVariavel.find(x => x.label === tipoVariavelNome);
    if (!tipoVariavel) {
      // Se não encontrar, usa formatação padrão
      return numValue.toFixed(1).replace('.', ',');
    }

    const estacaoColetaVariavel = this.estacaoColetas.find(x => x.tipo_variavel_id == tipoVariavel.value);
    const casasDecimais = estacaoColetaVariavel?.casas_decimais;

    // Se casas_decimais for null ou undefined, mantém formatação padrão (1 casa decimal)
    if (casasDecimais === null || casasDecimais === undefined) {
      return numValue.toFixed(1).replace('.', ',');
    }

    // Usa o número de casas decimais configurado
    return numValue.toFixed(casasDecimais).replace('.', ',');
  }


  ngOnInit(): void {
this.listTipos()
this.listEstacoes()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
      this.setupResizeObserver();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.ordenacaoAtual = null;

      if (!changes['value'].firstChange) {
        setTimeout(() => {
          this.calculateScrollHeight();
        }, 100);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 100);
  }

  setupResizeObserver(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement && typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.calculateScrollHeight();
      });
      this.resizeObserver.observe(this.tableWrapper.nativeElement);
    }
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperElement = this.tableWrapper.nativeElement;
      
      // Tenta encontrar o container pai para calcular altura disponível
      let containerElement = wrapperElement.closest('.variavel-container');
      if (!containerElement) {
        containerElement = wrapperElement.closest('.dashboard-content');
      }
      
      let availableHeight = wrapperElement.offsetHeight;
      
      if (containerElement) {
        const containerRect = (containerElement as HTMLElement).getBoundingClientRect();
        const wrapperRect = wrapperElement.getBoundingClientRect();
        
        // Calcula altura disponível considerando o container pai
        if (containerRect.height > 0) {
          // Encontra o header e toolbar para subtrair suas alturas
          const headerElement = wrapperElement.parentElement?.querySelector('.variavel-header');
          const toolbarElement = wrapperElement.parentElement?.querySelector('.variavel-toolbar');
          
          let headerHeight = 0;
          let toolbarHeight = 0;
          
          if (headerElement) {
            headerHeight = (headerElement as HTMLElement).offsetHeight || 50;
          }
          
          if (toolbarElement) {
            toolbarHeight = (toolbarElement as HTMLElement).offsetHeight || 60;
          }
          
          // Altura disponível = altura do container - header - toolbar - padding/margin
          availableHeight = containerRect.height - headerHeight - toolbarHeight - 20; // 20px para padding/margin
        }
      }
      
      // Se não encontrou container, usa a altura do wrapper
      if (availableHeight <= 0) {
        availableHeight = wrapperElement.offsetHeight;
      }
      
      // Subtrai altura do caption (~60px) e paginator (~60px)
      const calculatedHeight = availableHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 200)}px`;
    }
  }

  listTipos(){
    this.dropDownTipoVariavel = []
    this._variavelService.getType().subscribe(json => {
      json.map(item => {
        this.dropDownTipoVariavel.push({
          label: item.tipo_variavel, value: item.id
        })
      })
    })
  }
  listEstacoes(){
    this.dropDownEstacao = []
    this.dropDownEstacao.push({
      label: 'Selecione', value: 'null'
    })
    this._estacaoService.lookup().subscribe(json => {
      json.map(item => {
        this.dropDownEstacao.push({
          label: item.descricao, value: item.id
        })
      })
      this.estacao_id = 'null'
    })
  }

  filtrar() {
    this.value = [];
    this.columns = [];
    this.descricao_estacao = '';
    let tipo_variavel: any[] = [];
    this.dropDownTipoVariavel.map(item => {
        tipo_variavel.push(item.value);
    });
    
    let params = {
        data_inicial: moment(this.rangeDate[0]).format('YYYY-MM-DDT00:00:00'),
        data_final: moment(this.rangeDate[1]).format('YYYY-MM-DDT23:59:59'),
        estacao_id: this.estacao_id,
        tipo_variavel_id: tipo_variavel,
    };

    this._variavelService.filter(params).subscribe(json => {
        // Busca os dados da estação para ter acesso ao estacaoColetas
        if (json.length > 0 && json[0].estacao && json[0].estacao.id) {
          this._estacaoService.show(json[0].estacao.id).subscribe(estacaoJson => {
            if (estacaoJson.estacao && estacaoJson.estacao.estacao_coletas) {
              this.estacaoColetas = estacaoJson.estacao.estacao_coletas;
            }
            this.processarDados(json);
          });
        } else {
          this.processarDados(json);
        }
    });
  }

  private processarDados(json: any[]) {
    json.map(item => {
        item.data_hora_dados.map(dataItem => {
          const groupedData: any = { data: moment.utc(dataItem.data_hora_dado).format('DD/MM/YYYY HH:mm'), timestamp: new Date(dataItem.data_hora_dado).getTime() };
            dataItem.variaveis.map(variavelItem => {
                variavelItem.dados.map(dadoItem => {
                    let value = dadoItem.valor;
                    value = this.formatarValor(value, dadoItem.tipo_variavel.tipo_variavel);
                    groupedData[dadoItem.tipo_variavel.tipo_variavel] = value;
                });
            });
    
            this.value.push(groupedData);
            this.sortByKey(this.value, 'timestamp', 'desc')
        });
    });
    if (this.value.length > 0) {
        this.columns = Object.keys(this.value[0]).map(key => ({ field: key, header: key.toUpperCase() }));
    }
    this.descricao_estacao = json[0].estacao.descricao;
  }

sortByKey(array, key, type = 'asc') {
  return array.sort(function (a, b) {
    if (type == 'asc') {
      var x = a[key]; var y = b[key];
    } else {
      var x = b[key]; var y = a[key];
    }
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}

  onSort(event: SortEvent): void {
    if (!event.field || (event.order !== 1 && event.order !== -1)) {
      this.ordenacaoAtual = null;
      return;
    }

    this.ordenacaoAtual = {
      field: event.field,
      order: event.order
    };
  }

  private obterDadosOrdenadosParaExportacao(): any[] {
    const dados = [...(this.value || [])];

    if (!this.ordenacaoAtual) {
      return this.formatarPrimeiraColunaParaExportacao(dados);
    }

    const { field, order } = this.ordenacaoAtual;

    const dadosOrdenados = dados.sort((data1, data2) => {
      const value1 = this.obterValorCampo(data1, field);
      const value2 = this.obterValorCampo(data2, field);
      let result = 0;

      if (value1 == null && value2 != null) {
        result = -1;
      } else if (value1 != null && value2 == null) {
        result = 1;
      } else if (value1 != null && value2 != null) {
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          result = value1.localeCompare(value2);
        } else {
          result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
        }
      }

      return order * result;
    });

    return this.formatarPrimeiraColunaParaExportacao(dadosOrdenados);
  }

  private obterValorCampo(data: any, field: string): any {
    return field.split('.').reduce((value, key) => value?.[key], data);
  }

  private formatarPrimeiraColunaParaExportacao(dados: any[]): any[] {
    return dados.map((item) => {
      const linha = { ...item };

      Object.keys(linha).forEach((campo) => {
        if (['NIVEL', 'CHUVA'].includes(campo.trim().toUpperCase())) {
          linha[campo] = this.converterParaNumero(linha[campo]);
        }
      });

      if (typeof linha.data === 'string') {
        linha.data = linha.data.replace(
          /^(\d{2}\/\d{2}\/\d{4})\s+(\d{2}:\d{2}(?::\d{2})?)$/,
          '$1  $2'
        );
      }

      return linha;
    });
  }

  private converterParaNumero(valor: any): any {
    if (typeof valor === 'number') {
      return valor;
    }

    if (typeof valor !== 'string') {
      return valor;
    }

    const valorNormalizado = valor.trim().replace(',', '.');
    if (!valorNormalizado || !/^[+-]?\d+(\.\d+)?$/.test(valorNormalizado)) {
      return valor;
    }

    return Number(valorNormalizado);
  }

  exportPdf() {
    let exp: any[] = []
     
    exp = this.value;
    let col = this.columns.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default("landscape");


        (doc as any).autoTable(col, exp, {
          startY: (doc as any).autoTable() + 70,

          margin: { horizontal: 10 },
          styles: { overflow: "linebreak" },
          bodyStyles: { valign: "top" },
          columnStyles: { email: { columnHeight: 2 } },
          theme: "striped",
          showHead: "everyPage",
          didDrawPage: function (data) {

            // Header
            doc.setFontSize(15);
            doc.setTextColor(40);

            //Footer
            var str = "Pagina " + (doc as any).internal.getNumberOfPages();

            doc.setFontSize(10);

            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            doc.text(str, data.settings.margin.left, pageHeight - 10);
          }
        });


        doc.save(this.descricao_estacao+'.pdf');

      })
    })





  }

exportExcel() {
  const exp = this.obterDadosOrdenadosParaExportacao();

    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(exp);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, this.descricao_estacao );
    });
}

saveAsExcelFile(buffer: any, fileName: string): void {
    
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
 
}
}
